import { Autocomplete, ListItem, ListItemText, TextField } from "@mui/material";
// import { useMutation } from "react-query";
// import { searchPatient } from "../services";
import { ChangeEvent, useContext, useEffect, } from "react";
// import { PatientSearchLisType } from "../types";
import debounce from "../../../utilis/methods/networkHandling";
import { PatientBookingContext } from "./context/PatientBookingProvider";
import { PatientSearchData, useFetchPatientDetailsByEMR, usePatientSearch } from "../../hooks/apiHooks";
import moment from "moment";
function PatientSearch() {
  const {mutate,isLoading, data } = usePatientSearch();
  const { setEditDetails } = useContext(PatientBookingContext);

  const { mutate: fetchPatientDetails } = useFetchPatientDetailsByEMR({
    onSuccess: (result) => {
      if (result.response) {
        const { response } = result;
        let dob = "";
        if (moment(response.pmaster.dob, "DD/MM/YYYY", true).isValid()) {
          dob = moment(response.pmaster.dob, "DD/MM/YYYY").format("YYYY-MM-DD");
        } else {
          dob = response.pmaster.dob;
        }
        console.log(response.amaster);
        setEditDetails((prev) => ({
          ...prev,
          id: null,
          patientId: response.pmaster.patientId,
          firstName: response.pmaster.firstName,
          middleName: response.pmaster.middleName,
          lastName: response.pmaster.lastName,
          age: response.pmaster.age,
          dob,
          email: response.amaster.email || "",
          mobileNumber: response.amaster.mobileNo || "",
          gender: response.pmaster.gender,
          countryCode: {
            country_code: response.amaster.conCode,
            country_id: response.amaster.countryCode,
            id: `${response.amaster.countryCode}`,
            countryCode: response.amaster.conCode,
          },
          isCompleted:0,
          isRegistered:response.pmaster.isRegistered,
          bookingConfirmed:response.pmaster.bookingConfirmed,

        }));
      }
    },
  });

  const handleSearch = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target;
    mutate({searchText:value});
  };

  const debounceSearch = debounce(handleSearch, 300);

  const handlePatientSelect = (_: any, data: any) => {
    fetchPatientDetails({ emrNo: data.patientId });
  };
  useEffect(()=>{
  mutate({searchText:""})
  },[])
  return (
    <Autocomplete
      freeSolo
      id="free-solo-2-demo"
      disableClearable
      loading={isLoading}
      options={data?.response || []}
      filterOptions={(option) => option}
      isOptionEqualToValue={(option, value) => `${option.id}` == `${value.id}`}
      getOptionLabel={(option) =>
        `${(option as PatientSearchData).patientId} ${(option as PatientSearchData).firstName} ${(option as PatientSearchData).middleName ||""} ${(option as PatientSearchData).lastName}`
      }
      renderOption={(params, option:PatientSearchData) => (
        <ListItem {...params}>
          <ListItemText
            primary={`${option.patientId} ${option.firstName} ${option?.middleName || ""} ${option.lastName}`}
            secondary={option.mobileNo}
          />
        </ListItem>
      )}
      onChange={handlePatientSelect}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Search patient"
          InputProps={{
            ...params.InputProps,
            type: "search",
          }}
          onChange={debounceSearch}
        />
      )}
    />
  );
}

export default PatientSearch;
